import get from 'lodash.get';

const getFingerprintCdnUrl = (rootState) =>
  get(rootState, 'config.common.fingerprint.proxied_cdn_url', null);

export default getFingerprintCdnUrl;
